import { FC } from 'react'

import styled from 'styled-components'

import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { CTAButton } from 'src/Components/Buttons/CTAButton'

const ButtonsContainer = styled.div`
  position: fixed;
  z-index: 2;
  bottom: 0px;
  left: 0px;
  border-top: 1px solid ${({ theme }) => theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  display: flex;
  width: 100%;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 24px;
`

const StyledCTAButton = styled(CTAButton)`
  padding-left: 40px;
  padding-right: 40px;
`

type AdsCountriesModalButtonsProps = {
  disabledAdd: boolean
  onClickAddCountries: () => void
  onClickGoBack: () => void
}

export const AdsCountriesModalButtons: FC<AdsCountriesModalButtonsProps> = (
  props,
) => {
  const { disabledAdd, onClickAddCountries, onClickGoBack } = props
  return (
    <ButtonsContainer>
      <PrimaryDottedButton onClick={onClickGoBack}>Go Back</PrimaryDottedButton>
      <StyledCTAButton onClick={onClickAddCountries} disabled={disabledAdd}>
        Add target locations
      </StyledCTAButton>
    </ButtonsContainer>
  )
}
